<template>
	<div
			:class="{
				'fill-height': fillContainer || fillHeight,
				'fill-width': fillContainer || fillWidth,
			}"
	>
		<div
				v-if="isLoading"
				class="d-flex text-center fill-height"
		>
			<div class="ma-auto">
				<v-progress-circular
						indeterminate
						width="3"
				/>
				<div class="mt-3">
					{{ $t("pages.common.loading") }}
				</div>
			</div>
		</div>
		<template v-else>
			<slot />
		</template>
	</div>
</template>

<script>
export default {
  name: "LoadingComponent",
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: true,
    },
    fillContainer: {
      type: Boolean,
      required: false,
      default: false,
    },
    fillWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    fillHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
    afterLoad: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  watch: {
    isLoading() {
      this.$nextTick(async () => {
        await this.afterLoad();
      });
    },
  },
};
</script>
